import axiosInstance from './AxiosInstance';

export function getCities() {
    return axiosInstance.get(`/cities`);
}

export function createCity(cityData) {
    return axiosInstance.post(`/city`, cityData);
}

export function updateCity(city) {
    return axiosInstance.put(`/city/update`, city);
}

export function deleteCity(cityId) {
    return axiosInstance.delete(`/city/${cityId}`);
}
